import { useCurrency } from '@/contexts/CurrencyContext';

/**
 * Compact pill toggle: [ USD | IDR ]
 *
 * Variants:
 *  - "navbar"  → tight, light-on-dark + dark-on-light auto via tw classes
 *  - "page"    → larger, used on Browse pages near filters
 */
const CurrencySwitcher = ({ variant = 'navbar', className = '' }) => {
  const { currency, setCurrency } = useCurrency();

  const sizeClass =
    variant === 'page'
      ? 'text-sm h-9 px-3'
      : 'text-xs h-8 px-2.5';

  const buttonBase = `inline-flex items-center justify-center font-medium rounded-full transition-colors ${sizeClass}`;
  const active = 'bg-ubud-jungle text-white shadow-sm';
  const inactive = 'text-charcoal-muted hover:text-charcoal';

  return (
    <div
      className={`inline-flex items-center bg-warm-sand/80 border border-warm-sand rounded-full p-0.5 ${className}`}
      data-testid="currency-switcher"
      role="group"
      aria-label="Currency selector"
    >
      <button
        type="button"
        onClick={() => setCurrency('USD')}
        className={`${buttonBase} ${currency === 'USD' ? active : inactive}`}
        data-testid="currency-usd"
        aria-pressed={currency === 'USD'}
      >
        USD
      </button>
      <button
        type="button"
        onClick={() => setCurrency('IDR')}
        className={`${buttonBase} ${currency === 'IDR' ? active : inactive}`}
        data-testid="currency-idr"
        aria-pressed={currency === 'IDR'}
      >
        IDR
      </button>
    </div>
  );
};

export default CurrencySwitcher;
